import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Icon } from 'components/atoms';
import { darken } from 'polished';

const ActionTriangle = ({ className, onClick }) => (
  <Wrapper className={className} role="button" onClick={onClick}>
    <IconWrapper>
      <Icon icon="add" height={14} />
    </IconWrapper>
  </Wrapper>
);

ActionTriangle.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

ActionTriangle.defaultProps = {
  className: '',
  onClick: () => null,
};

const IconWrapper = styled.div`
  z-index: 1;
  cursor: pointer;
`;

const Wrapper = styled.div`
  width: 24.7px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover::before {
    background-color: ${props => darken(0.04, props.theme.colors.bgLighter)};
    color: ${props => props.theme.colors.base};
    cursor: pointer;
  }
  &:focus::before {
    outline: 0;
    color: ${props => props.theme.colors.base};
    background-color: ${props => darken(0.03, props.theme.colors.bg)};
  }
  &:active::before {
    background-color: ${props => props.theme.colors.bgLighter};
  }
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: ${props => props.theme.sizes.xl3};
    height: ${props => props.theme.sizes.xl3};
    transform: rotate(45deg);
    background-color: ${props => props.theme.colors.bgLighter};
    border-top: 1px solid ${props => props.theme.colors.borderLighter};
    border-left: 1px solid ${props => props.theme.colors.borderLighter};
  }
`;

export default ActionTriangle;
